module.exports = __webpack_public_path__ + "media/img/photo4-0ebed46e.jpg";